import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';

@Component({
  selector: 'app-cej-v2-banner',
  templateUrl: './cej-v2-banner.component.html',
  styleUrls: ['./cej-v2-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CejV2BannerComponent {
  FeaturesRoutingEnum = FeaturesRoutingEnum;
}

@NgModule({
  imports: [CommonModule, MatIconModule, RouterModule],
  declarations: [CejV2BannerComponent],
  exports: [CejV2BannerComponent],
})
export class CejV2BannerModule {}
